import React from 'react';
var TorpedoItem = function (props) {
    var item = props.item, renderItem = props.renderItem;
    var itemStyle = {
        width: item.width,
        height: item.height,
    };
    var wrapStyles = {
        width: item.width,
        height: '100%',
        display: 'inline-block',
        float: 'left',
        position: 'relative',
        margin: item.margins,
    };
    // TODO pass down the onscreen prop from pro gallery
    return (React.createElement("div", { key: "item-" + item.idx, style: wrapStyles }, renderItem(props, item, itemStyle)));
};
TorpedoItem.displayName = 'TorpedoItem';
export default TorpedoItem;
//# sourceMappingURL=Item.js.map